module.exports = "aside.pcoded-slider.ng-sidebar {\n  top: 56px; }\n\n.slimscroll-wrapper, .scroll-window {\n  width: 100% !important; }\n\n.userlist-box.show {\n  display: -webkit-box; }\n\n.userlist-box.hide {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin/admin.component.scss
// module id = ./src/app/layouts/admin/admin.component.scss
// module chunks = main